import { render, staticRenderFns } from "./GroupOfAccreditationStepInfo.vue?vue&type=template&id=3aa13c0c&scoped=true"
import script from "./GroupOfAccreditationStepInfo.vue?vue&type=script&lang=js"
export * from "./GroupOfAccreditationStepInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupOfAccreditationStepInfo.vue?vue&type=style&index=0&id=3aa13c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa13c0c",
  null
  
)

export default component.exports